import EcommerceIcon from "assets/icons/EcommerceIcon"
import AppointmentIcon from "assets/icons/AppointmentIcon"
import VideoIcon from "assets/icons/VideoIcon"
import CouponIcon from "assets/icons/CouponIcon"
import LearningPlatformIcon from "assets/icons/LearningPlatformIcon"
import GuestManagementIcon from "assets/icons/GuestManagementIcon"
import HomeIcon from "assets/icons/HomeIcon"
import CompanyProfileIcon from "assets/icons/CompanyProfileIcon"

import adelaide from "assets/images/companies/adelaide.png"
import aesop from "assets/images/companies/aesop.png"
import glossier from "assets/images/companies/glossier.png"
import mecca from "assets/images/companies/mecca.png"
import rmit from "assets/images/companies/rmit.png"

import product1item1 from "assets/images/products/product1/item1.png"
import product1item2 from "assets/images/products/product1/item2.png"
import product1item3 from "assets/images/products/product1/item3.png"
import product1item4 from "assets/images/products/product1/item4.png"

import showcase4 from "assets/images/showcase/showcase-4.png"

import commerceHero from "assets/images/products/product1/commerce/hero-products.png"
import commerceDashboard from "assets/images/products/product1/commerce/dashboard.png"
import commerceCatalog from "assets/images/products/product1/commerce/catalog-variants.png"
import commerceStorefront from "assets/images/products/product1/commerce/storefront.png"
import commerceOrders from "assets/images/products/product1/commerce/orders.png"
import commerceCheckout from "assets/images/products/product1/commerce/checkout.png"
import commerceWhatsappOrders from "assets/images/products/product1/commerce/whatsapp-orders.png"
import commerceShipping from "assets/images/products/product1/commerce/shipping.png"
import commerceCoupons from "assets/images/products/product1/commerce/coupons.png"
import commerceEmails from "assets/images/products/product1/commerce/emails.png"
import commercePurchasing from "assets/images/products/product1/commerce/purchasing.png"
import commerceInventory from "assets/images/products/product1/commerce/inventory.png"
import commerceFinance from "assets/images/products/product1/commerce/finance.png"
import commerceInvoices from "assets/images/products/product1/commerce/invoices.png"
import commerceSettlements from "assets/images/products/product1/commerce/settlements.png"
import commerceTeam from "assets/images/products/product1/commerce/team.png"


import product2main from "assets/images/products/product2/appointment-main.png"
import product2feature1 from "assets/images/products/product2/personalized-branding.png"
import product2feature2 from "assets/images/products/product2/complete-with-payment-system.png"
import product2feature3 from "assets/images/products/product2/automated-workflows.png"
import product2feature4 from "assets/images/products/product2/detailed-booking-reports.png"
import product2feature5 from "assets/images/products/product2/modify-slot-through-cms.png"
import product2feature6 from "assets/images/products/product2/responsive-site.png"
import product2feature7 from "assets/images/products/product2/highlight-appointment.png"
import product2feature8 from "assets/images/products/product2/order-details.png"


import product3main from "assets/images/products/product3/company-profile-main.png"
import product3feature1 from "assets/images/products/product3/premium-web-interface.png"
import product3feature2 from "assets/images/products/product3/cms-complete.png"
import product3feature3 from "assets/images/products/product3/blog-feature.png"
import product3feature4 from "assets/images/products/product3/responsive-site.png"


const style1 = {
    className: "bg-maplexxon-grey-light",
    itemGroupClassName: "grid grid-cols-1 sm:grid-cols-2 gap-12 lg:gap-8 justify-start items-center mt-12 max-w-3xl mx-auto",
    itemClassName: "flex gap-2 lg:gap-4 flex-col items-center justify-start",
    itemTextClassName: "flex flex-col gap-2 lg:gap-4 text-center",
}

const style2 = {
    className: "bg-white",
    itemGroupClassName: "flex flex-col flex-wrap gap-8 justify-center items-center mt-20",
    itemClassName: `flex flex-col md:flex-row gap-2 md:gap-20 md:w-item-1 items-center justify-start`,
    itemAlternating: true,
    itemTextClassName: "lg:w-1/2 flex flex-col gap-2 lg:gap-4 text-center lg:text-left",
}

const style3 = {
    className: "bg-maplexxon-grey-light",
    itemGroupClassName: "flex flex-wrap gap-8 justify-center items-center mt-12",
    itemClassName: "flex gap-8 lg:w-item-4 flex-col items-center justify-center",
    itemTextClassName: "flex flex-col gap-2 lg:gap-4 text-left",
}

// Maplexxon Commerce: features included in every plan, grouped for the pricing page.
// Plan limits and hosting differ per plan and are added in makeCommercePlan below.
const commerceFeatureGroups = [
    {
        group: "Online store",
        items: [
            "Your own domain with SSL",
            "Your branding (logo, colours, fonts, layouts)",
            "Home page editor with live preview",
            "Product variants, shade swatches and categories",
            "Auto-optimised product photos in several sizes",
            "Bulk product import (CSV) with preview",
            "Store interface in Bahasa Indonesia and English",
            "Content pages (about, FAQ, policies)",
            "SEO titles, sitemap and WhatsApp share previews",
        ],
    },
    {
        group: "Selling & payments",
        items: [
            "Midtrans checkout (QRIS, virtual accounts, e-wallets, cards, paylater)",
            "Choose who pays the payment fee, per method",
            "Discount coupons",
            "Order tracking page for buyers",
            "Manual & WhatsApp orders entered by staff",
            "Payment links you can send to buyers",
            "Customer list with credit terms and statements",
        ],
    },
    {
        group: "Shipping",
        items: [
            "Biteship courier rates, booking, labels and tracking",
            "Instant couriers with a map pin",
            "Store pickup and flat-rate shipping",
            "Courier returns and lost-parcel handling",
        ],
    },
    {
        group: "Purchasing & inventory",
        items: [
            "Suppliers and purchase orders (PDF, WhatsApp)",
            "Goods receiving, including partial deliveries",
            "Returns to suppliers",
            "Stock valued at average cost",
            "Low-stock alerts and reorder suggestions",
            "Record marketplace sales and stock write-offs",
        ],
    },
    {
        group: "Finance",
        items: [
            "Invoices, receipts and credit notes as PDF",
            "Down payments and instalment terms",
            "Receivables and payables with aging",
            "Automatic payment reminders",
            "Expenses and a cash & bank book",
            "Profit after cost of goods sold (HPP)",
            "PPN handling, including input PPN",
            "Midtrans payout matching",
            "Refunds",
        ],
    },
    {
        group: "Team & reports",
        items: [
            "Five staff roles with 2-step verification",
            "Dashboard for sales, orders, stock and money",
            "CSV exports for your bookkeeper",
            "New-order alerts and a daily summary by email",
            "Branded automatic emails to buyers",
            "Email delivery log",
        ],
    },
    {
        group: "Included service",
        items: [
            "Daily backups",
            "Support and maintenance",
        ],
    },
]

const makeCommercePlan = ({ limits, ...plan }) => ({
    ...plan,
    features: [
        { group: "Plan details", text: "Monthly orders (fair use)", value: limits.orders },
        { group: "Plan details", text: "Products", value: limits.products },
        { group: "Plan details", text: "Monthly store visits", value: limits.visits },
        { group: "Plan details", text: "Hosting", value: limits.hosting },
        limits.imageCdn
            ? { group: "Plan details", text: "Image CDN for faster photo delivery", value: "Included" }
            : { group: "Plan details", text: "Image CDN for faster photo delivery", value: "Not included", excluded: true },
        ...commerceFeatureGroups.flatMap(({ group, items }) => items.map(text => ({ group, text }))),
    ],
})

export const products = [
    {
        id: 1,
        name: "Ecommerce Website",
        description: "Online store with Midtrans checkout and Biteship shipping, plus inventory, purchasing and finance tools for sellers in Indonesia. Hosting, backups and support included.",
        slug: "ecommerce-website",
        icon: EcommerceIcon,
        beta: false,
        details: {
            title: "Sell online, run the back office too",
            subtitle: (
                <>
                    <p>
                        Maplexxon Commerce is an online store for sellers in Indonesia. Buyers pay with QRIS, virtual accounts, e-wallets, cards or paylater through Midtrans, and you ship with Biteship couriers.
                    </p><br />
                    <p>
                        Behind the storefront you get purchasing, inventory, invoices, expenses and bookkeeping that keeps itself up to date. Hosting, daily backups and support are included in every plan.
                    </p>
                </>
            ),
            img: commerceHero,
            brands: [
                {
                    id: 1,
                    name: "aesop",
                    src: aesop
                },
                {
                    id: 2,
                    name: "rmit",
                    src: rmit
                },
                {
                    id: 3,
                    name: "glossier",
                    src: glossier
                },
                {
                    id: 4,
                    name: "mecca",
                    src: mecca
                },
                {
                    id: 5,
                    name: "adelaide",
                    src: adelaide
                },
            ],
            body: [
                {
                    title: "Built for how shops sell in Indonesia",
                    className: style1.className,
                    itemGroupClassName: style1.itemGroupClassName,
                    itemClassName: style1.itemClassName,
                    itemTextClassName: style1.itemTextClassName,
                    items: [
                        {
                            img: product1item1,
                            title2: "A store that is ready to sell, without a dev team",
                            description: "We set up your store on your own domain with your logo, colours and fonts. Add products one by one or upload them in bulk from a CSV file."
                        },
                        {
                            img: product1item2,
                            title2: "Checkout your buyers already know",
                            description: "Buyers pay through Midtrans with QRIS, virtual accounts, e-wallets, cards or paylater. You can also send a payment link to buyers who order through chat."
                        },
                        {
                            img: product1item3,
                            title2: "From new order to delivered parcel",
                            description: "Courier rates come from Biteship at checkout. Book the pickup, print the label and follow tracking from the order page, while buyers follow their parcel on a tracking page."
                        },
                        {
                            img: product1item4,
                            title2: "Works on phones, tablets and desktops",
                            description: "Buyers can switch the store between Bahasa Indonesia and English, and every page is laid out to read well on a phone as well as a desktop."
                        },
                    ]
                },
                {
                    name: "features",
                    title: "A look inside",
                    description: "These are real screens from Maplexxon Commerce, filled with a demo shop. Everything shown is included in all plans. Plans differ in order volume, catalog size, store traffic and hosting.",
                    className: style2.className,
                    itemGroupClassName: style2.itemGroupClassName,
                    itemClassName: style2.itemClassName,
                    itemAlternating: style2.itemAlternating,
                    itemTextClassName: style2.itemTextClassName,
                    items: [
                        {
                            img: commerceDashboard,
                            title: "Start the day knowing what needs doing",
                            description: "The dashboard shows today's sales, orders waiting to be packed or shipped, low stock, money received and money still owed to you. Anything that needs a decision shows up at the top."
                        },
                        {
                            img: commerceStorefront,
                            title: "A store that looks like your brand",
                            description: (
                                <>
                                    <p>Pick your colours, fonts, button shapes and layouts, and arrange the home page with a block editor that shows a live preview.</p>
                                    <br />
                                    <p>Every page gets its own title, description and share preview, so products look right on Google and when buyers send them on WhatsApp.</p>
                                </>
                            )
                        },
                        {
                            img: commerceCatalog,
                            title: "Variants, shades and stock per item",
                            description: "Give each product sizes, colours or shades with their own price, SKU, weight and stock. Add products one by one or import hundreds from a CSV file, with a preview before anything changes."
                        },
                        {
                            img: commerceCheckout,
                            title: "Checkout with every way Indonesians pay",
                            description: "Buyers pay with QRIS, virtual accounts, e-wallets, cards or paylater through Midtrans. You decide per method whether the shop or the buyer covers the fee, and buyers see it before they pay."
                        },
                        {
                            img: commerceOrders,
                            title: "Every order, from paid to delivered",
                            description: "Filter orders by payment, packing or delivery status. Each order shows what to pack, the invoice, the payments and the courier shipment, so your team knows the next step."
                        },
                        {
                            img: commerceWhatsappOrders,
                            title: "Orders from WhatsApp and walk-in buyers",
                            description: (
                                <>
                                    <p>Staff can enter orders that come in by chat or at the counter, with special prices, a down payment or payment terms for trusted customers.</p>
                                    <br />
                                    <p>Send the buyer a payment link and they pay with the method they like. Instalments are collected through the same link.</p>
                                </>
                            )
                        },
                        {
                            img: commerceShipping,
                            title: "Biteship couriers, booked from the order",
                            description: (
                                <>
                                    <p>Buyers see courier rates at checkout. You book the pickup, print labels in bulk and follow tracking without leaving the admin. Buyers follow their parcel on a tracking page.</p>
                                    <br />
                                    <p>Store pickup, flat rates by province and instant couriers are available too.</p>
                                </>
                            )
                        },
                        {
                            img: commerceCoupons,
                            title: "Coupons with the limits you need",
                            description: "Create percent or fixed coupons with a minimum spend, a cap, a validity period and a quota per customer, or limit them to certain products. See how often each one was used."
                        },
                        {
                            img: commerceEmails,
                            title: "Emails that go out on their own",
                            description: "Buyers get branded emails when their order is received, paid, shipped and delivered. Your team gets new-order alerts and a daily summary, and chooses which alerts they want."
                        },
                        {
                            img: commercePurchasing,
                            title: "Purchase orders to your suppliers",
                            description: "Order stock from suppliers with PPN and extra costs, send the PO as a PDF or by WhatsApp, and receive goods in one go or in parts. Warehouse staff can receive goods without seeing prices."
                        },
                        {
                            img: commerceInventory,
                            title: "Know what to reorder, and what your stock is worth",
                            description: "Stock is valued at average cost, including shipping from the supplier. The reorder tab suggests quantities and turns them into a purchase order. Sales on marketplaces and damaged goods can be recorded too."
                        },
                        {
                            img: commerceFinance,
                            title: "See your real profit",
                            description: "The finance overview shows sales, cost of goods sold, gross profit, expenses, gateway fees and your PPN position. Every number has an explanation, and your bookkeeper can download it all as CSV."
                        },
                        {
                            img: commerceInvoices,
                            title: "Invoices, instalments and who still owes you",
                            description: "Invoices and receipts come as PDF. Set up a down payment and instalments, see receivables by age, and let the system send payment reminders before and after the due date."
                        },
                        {
                            img: commerceSettlements,
                            title: "Match Midtrans payouts to your orders",
                            description: "Import the Midtrans payout report and every transaction is matched to its order with the real fee. The cash and bank book keeps running balances for each account."
                        },
                        {
                            img: commerceTeam,
                            title: "Give each person the right access",
                            description: "Invite staff as owner, manager, finance, warehouse or view only. Owners and finance staff sign in with 2-step verification."
                        },
                    ]
                },
                {
                    title: "Everything else that comes with it",
                    description: "Purchasing, stock, invoices and the books live in the same system as your orders, so you do not retype numbers into a separate spreadsheet.",
                    className: style3.className,
                    itemGroupClassName: "grid grid-cols-1 sm:grid-cols-2 gap-x-12 gap-y-10 mt-12 max-w-3xl mx-auto",
                    itemClassName: "flex flex-col items-start justify-start",
                    itemTextClassName: style3.itemTextClassName,
                    items: commerceFeatureGroups
                        .filter(({ group }) => ["Purchasing & inventory", "Finance", "Team & reports", "Included service"].includes(group))
                        .map(({ group, items }) => ({ title3: group, list: items.map(text => ({ text })) })),
                },
            ],
            // useCases: [
            //     {
            //         icon: HomeIcon,
            //         label: "Fashion"
            //     },
            //     {
            //         icon: HomeIcon,
            //         label: "Home and decor"
            //     },
            //     {
            //         icon: HomeIcon,
            //         label: "Food"
            //     },
            //     {
            //         icon: HomeIcon,
            //         label: "Real estate"
            //     },
            //     {
            //         icon: HomeIcon,
            //         label: "Local business"
            //     },
            //     {
            //         icon: HomeIcon,
            //         label: "Restaurant"
            //     },
            // ]
        },
        pricings: [
            makeCommercePlan({
                id: 1,
                name: "Starter",
                description: "For new or small shops moving online from WhatsApp or Instagram.",
                corePrice: 10000000,
                monthlyPrice: 449000,
                discountedMonthlyPrice: 381667,
                annualPrice: 4580000,
                priceDescriptionText: "Save up to 15% annually",
                limits: { orders: "Up to 300", products: "Up to 200", visits: "Up to 5,000", hosting: "Standard hosting", imageCdn: false },
            }),
            makeCommercePlan({
                id: 2,
                name: "Growth",
                description: "For established shops that sell every day.",
                corePrice: 15000000,
                monthlyPrice: 1790000,
                discountedMonthlyPrice: 1520833,
                annualPrice: 18250000,
                priceDescriptionText: "Save up to 15% annually",
                mostPopular: true,
                limits: { orders: "Up to 2,000", products: "Up to 1,000", visits: "Up to 30,000", hosting: "Dedicated server", imageCdn: false },
            }),
            makeCommercePlan({
                id: 3,
                name: "Pro",
                description: "For large shops with high traffic and big catalogs.",
                corePrice: 20000000,
                monthlyPrice: 4990000,
                discountedMonthlyPrice: 4241667,
                annualPrice: 50900000,
                priceDescriptionText: "Save up to 15% annually",
                limits: { orders: "Up to 10,000", products: "5,000+", visits: "150,000+", hosting: "Dedicated server, higher capacity", imageCdn: true },
            }),
        ],
    },
    {
        id: 2,
        name: "Appointment and Scheduling Management",
        comingSoon: true,
        comingSoonText: "Online booking for appointments and classes is being built. It is not available yet, but you can talk to our team about it now.",
        description: "Manage appointments and help your customers book services easily.",
        slug: "appointment-and-scheduling-management",
        icon: AppointmentIcon,
        beta: false,
        details: {
            title: "Give your customers a seamless booking experience",
            subtitle: "The Maplexxon software makes it easy for your customers to make direct booking or appointments through a website. Complete with automated workflows when booking is made.",
            img: product2main,
            brands: [
                {
                    id: 1,
                    name: "aesop",
                    src: aesop
                },
                {
                    id: 2,
                    name: "rmit",
                    src: rmit
                },
                {
                    id: 3,
                    name: "glossier",
                    src: glossier
                },
                {
                    id: 4,
                    name: "mecca",
                    src: mecca
                },
                {
                    id: 5,
                    name: "adelaide",
                    src: adelaide
                },
            ],
            body: [
                {
                    name: "features",
                    className: style2.className,
                    itemGroupClassName: style2.itemGroupClassName,
                    itemClassName: style2.itemClassName,
                    itemAlternating: style2.itemAlternating,
                    itemTextClassName: style2.itemTextClassName,
                    items: [
                        {
                            img: product2feature1,
                            title: "Personalised site with your own branding",
                            description: "Have your appointment and scheduling site branded with your brand logo. Simply give your brand logo and select the colors and tone based on your preferences that are aligned with your brand."
                        },
                        {
                            img: product2feature2,
                            title: "Complete with payment system",
                            description: "You may take payment upfront once your customers book the appointment. Allowing customers to proceed the booking process with a variety of payment options."
                        },
                        {
                            img: product2feature3,
                            title: "Automated workflows",
                            description: "Once appointment is made by your customers, email reminders are automatically set up to make your administration hassle free."
                        },
                        {
                            img: product2feature7,
                            title: "Streamline scheduling process through calendar preview",
                            description: "Our automated system keeps both internal admin and your customners in the loop, reducing missed appointments and ensuring everyone stays on track."
                        },
                        {
                            img: product2feature4,
                            title: "Detailed booking reports",
                            description: "Analyze booking or appointment details database and turn into insightful marketing efforts. Booking reports will be automatically sent to administrators emails each week or month."
                        },
                        {
                            img: product2feature5,
                            title: "Modify slot availability through our powerful CMS",
                            description: "We provide Content Management System (CMS), enabling your internal admin to add or update slot availability for your services."
                        },
                        {
                            img: product2feature6,
                            title: "Responsive site that are accessible through website, tablet or mobile",
                            description: "Seamlessly connecting your customer dynamically from various screens."
                        },
                        {
                            img: product2feature8,
                            title: "View customer and order details just a single tap away",
                            description: "With just a few clicks, you can view order details, customer information, check appointment detail and status effortlessly."
                        },
                    ]
                },
            ],
        },
        // Pricing is commented out while the product is marked comingSoon.
        // pricings: [
        //     {
        //         id: 1,
        //         name: "Essential",
        //         description: "Lorem ipsum dolor sit amet",
        //         corePrice: 8000000,
        //         monthlyPrice: 699000,
        //         discountedMonthlyPrice: 608333,
        //         annualPrice: 7300000,
        //         priceDescriptionText: "Save up to 15% annually",
        //         features: [
        //             {
        //                 text: "Custom domain",
        //             },
        //             {
        //                 text: "SSL certificate",
        //             },
        //             {
        //                 text: "Automatic data backup",
        //             },
        //             {
        //                 text: "Support and maintenance",
        //             },
        //             {
        //                 text: "Responsive web design",
        //             },
        //             {
        //                 text: "Automated email workflows",
        //             },
        //             {
        //                 text: "Maplexxon logo on footer",
        //             },
        //             {
        //                 text: "Customer support via chat",
        //             },
        //         ]
        //     },
        //     {
        //         id: 2,
        //         name: "Professional",
        //         description: "Lorem ipsum dolor sit amet",
        //         corePrice: 10000000,
        //         monthlyPrice: 999000,
        //         discountedMonthlyPrice: 875000,
        //         annualPrice: 10500000,
        //         priceDescriptionText: "Save up to 15% annually",
        //         mostPopular: true,
        //         features: [
        //             {
        //                 text: "Custom domain",
        //             },
        //             {
        //                 text: "SSL certificate",
        //             },
        //             {
        //                 text: "Automatic data backup",
        //             },
        //             {
        //                 text: "Support and maintenance",
        //             },
        //             {
        //                 text: "Responsive web design",
        //             },
        //             {
        //                 text: "Automated email workflows",
        //             },
        //             {
        //                 text: "Maplexxon logo on footer",
        //             },
        //             {
        //                 text: "Customer support via chat",
        //             },
        //             {
        //                 text: "Multi user account access",
        //                 value: "Up to 2 accounts"
        //             },
        //             {
        //                 text: "Integrated with payment system",
        //             },
        //             {
        //                 text: "Sync with Google Calendar",
        //             },
        //             {
        //                 text: "In web chat widget",
        //             },
        //             {
        //                 text: "Upload logo and brand colors",
        //             },
        //         ]
        //     },
        // ],
    },
    {
        id: 3,
        name: "Company Profile Site",
        description: "Present a professional website for your company or own brand.",
        slug: "company-profile-site",
        icon: CompanyProfileIcon,
        beta: false,
        details: {
            title: "Present a professional website for your company or own brand",
            subtitle: "Get the premium website with rich feature listings.",
            img: product3main,
            body: [
                {
                    name: "features",
                    className: style2.className,
                    itemGroupClassName: style2.itemGroupClassName,
                    itemClassName: style2.itemClassName,
                    itemAlternating: style2.itemAlternating,
                    itemTextClassName: style2.itemTextClassName,
                    items: [
                        {
                            img: product3feature1,
                            title: "Premium website interface",
                            description: "Give customers the best experience when accessing your website. The site comes with user-friendly interface"
                        },
                        {
                            img: product3feature2,
                            title: "Customizable website powered with CMS",
                            description: (
                                <>
                                    You can easily edit/update all website contents from the Content Management System (CMS). Maplexxon provides CMS training with our support team upon setting up your website.
                                    <br />
                                    <br />
                                    Additionally, we do offer a content management service to help you save your time so you can focus on running your business.
                                </>
                            )
                        },
                        {
                            img: product3feature3,
                            title: "Blogging features",
                            description: "Have your website complete with blog posts and its workflow. You can easily publish or save post as draft in the content editor."
                        },
                        {
                            img: product3feature4,
                            title: "Responsive site that are accessible through website, tablet or mobile",
                            description: "Seamlessly connecting your customer dynamically from various screens."
                        },
                        // {
                        //     img: product1item3,
                        //     title: "Build customer database through newsletter sign up",
                        // },
                    ]
                },
            ],
        },
        pricings: [
            {
                id: 1,
                name: "Essential",
                description: "Lorem ipsum dolor sit amet",
                corePrice: 6000000,
                monthlyPrice: 650000,
                discountedMonthlyPrice: 583333,
                annualPrice: 7000000,
                priceDescriptionText: "Save up to 15% annually",
                features: [
                    {
                        text: "Custom domain",
                    },
                    {
                        text: "SSL certificate",
                    },
                    {
                        text: "Automatic data backup",
                    },
                    {
                        text: "Support and maintenance",
                    },
                    {
                        text: "Responsive web design",
                    },
                    {
                        text: "UI Design template",
                    },
                    {
                        text: "Maplexxon logo on footer",
                    },
                    {
                        text: "Customer support via chat",
                    },
                ]
            },
            {
                id: 2,
                name: "Professional",
                description: "Lorem ipsum dolor sit amet",
                corePrice: 8000000,
                monthlyPrice: 950000,
                discountedMonthlyPrice: 850000,
                annualPrice: 10200000,
                priceDescriptionText: "Save up to 15% annually",
                mostPopular: true,
                features: [
                    {
                        text: "Custom domain",
                    },
                    {
                        text: "SSL certificate",
                    },
                    {
                        text: "Automatic data backup",
                    },
                    {
                        text: "Support and maintenance",
                    },
                    {
                        text: "Responsive web design",
                    },
                    {
                        text: "UI Design template",
                    },
                    {
                        text: "Maplexxon logo on footer",
                    },
                    {
                        text: "Customer support via chat",
                    },
                    {
                        text: "In web chat widget",
                    },
                    {
                        text: "Blog posts",
                    },
                    {
                        text: "Mailchimp integration for newsletter",
                    },
                    {
                        text: "Contact form page",
                    },
                    {
                        text: "Multi user account access",
                        value: "Up to 2 accounts"
                    },
                    {
                        text: "Contact form inquiry sent to email",
                    },
                    {
                        text: "Add downloadable file on specific pages",
                    },
                ]
            },
        ],
    },
    {
        id: 4,
        name: "On-demand Learning Platform and Microsite",
        description: "Create and share your own lessons through a ready-made learning platform.",
        slug: "on-demand-learning-platform-and-microsite",
        icon: LearningPlatformIcon,
        beta: true,
        details: {
            title: "All in one online store to sell your products",
            subtitle: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique. Nec in est cursus eu et id viverra scelerisque gravida. ",
            img: product1item4,
            brands: [
                {
                    id: 1,
                    name: "aesop",
                    src: aesop
                },
                {
                    id: 2,
                    name: "rmit",
                    src: rmit
                },
                {
                    id: 3,
                    name: "glossier",
                    src: glossier
                },
                {
                    id: 4,
                    name: "mecca",
                    src: mecca
                },
                {
                    id: 5,
                    name: "adelaide",
                    src: adelaide
                },
            ],
            body: [
                {
                    title: "Build ecommerce site simpler with easy-to-use interface",
                    className: style1.className,
                    itemGroupClassName: style1.itemGroupClassName,
                    itemClassName: style1.itemClassName,
                    itemTextClassName: style1.itemTextClassName,
                    items: [
                        {
                            img: product1item1,
                            title2: "Show product catalogs with",
                            description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
                        },
                        {
                            img: product1item1,
                            title2: "Manage product inventory",
                            description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
                        },
                        {
                            img: product1item1,
                            title2: "Easily manage orders and set shipping options",
                            description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
                        },
                        {
                            img: product1item1,
                            title2: "Notifications for low stock alerts",
                            description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
                        },
                        {
                            img: product1item1,
                            title2: "Connect and integrate with marketplace",
                            description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
                        },
                        {
                            img: product1item1,
                            title2: "Add custom discounts or coupons",
                            description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
                        },
                    ]
                },
                {
                    name: "features",
                    title: "Ecommerce website that built with exciting core features",
                    description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique. Nec in est cursus eu et id viverra scelerisque gravida.",
                    className: style2.className,
                    itemGroupClassName: style2.itemGroupClassName,
                    itemClassName: style2.itemClassName,
                    itemAlternating: style2.itemAlternating,
                    itemTextClassName: style2.itemTextClassName,
                    items: [
                        {
                            img: product1item2,
                            title: "View comprehensive analytics of your store",
                            description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
                        },
                        {
                            img: product1item3,
                            title: "Complete with access management level",
                            description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
                        },
                        {
                            img: product1item4,
                            title: "Automatic orders management",
                            description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
                        },
                    ]
                },
                {
                    title: "Lorem ipsum dolor sit amet",
                    className: style3.className,
                    itemGroupClassName: style3.itemGroupClassName,
                    itemClassName: style3.itemClassName,
                    itemTextClassName: style3.itemTextClassName,
                    items: [
                        {
                            title3: "Lorem ipsum",
                            list: [
                                {
                                    text: "Custom shipping fee",
                                },
                                {
                                    text: "Add product variants",
                                },
                                {
                                    text: "Customizable field for product information",
                                },
                            ]
                        },
                        {
                            title3: "Lorem ipsum",
                            list: [
                                {
                                    text: "Custom shipping fee",
                                },
                                {
                                    text: "Add product variants",
                                },
                                {
                                    text: "Customizable field for product information",
                                },
                            ]
                        },
                        {
                            title3: "Lorem ipsum",
                            list: [
                                {
                                    text: "Custom shipping fee",
                                },
                                {
                                    text: "Add product variants",
                                },
                                {
                                    text: "Customizable field for product information",
                                },
                            ]
                        },
                        {
                            title3: "Lorem ipsum",
                            list: [
                                {
                                    text: "Custom shipping fee",
                                },
                                {
                                    text: "Add product variants",
                                },
                                {
                                    text: "Customizable field for product information",
                                },
                            ]
                        },
                    ]
                },
            ],
            useCases: [
                {
                    icon: HomeIcon,
                    label: "Fashion"
                },
                {
                    icon: HomeIcon,
                    label: "Home and decor"
                },
                {
                    icon: HomeIcon,
                    label: "Food"
                },
                {
                    icon: HomeIcon,
                    label: "Real estate"
                },
                {
                    icon: HomeIcon,
                    label: "Local business"
                },
                {
                    icon: HomeIcon,
                    label: "Restaurant"
                },
            ]
        },
        pricings: [
            {
                id: 1,
                name: "Starter",
                description: "Lorem ipsum dolor sit amet",
                corePrice: 9000000,
                monthlyPrice: 799000,
                annualPrice: 8500000,
                priceDescriptionText: "Save up to 15% annually",
                features: [
                    {
                        id: 1,
                        text: "Lorem ipsum dolor sit amet",
                    },
                    {
                        id: 2,
                        text: "Lorem ipsum dolor sit amet",
                    },
                    {
                        id: 3,
                        text: "Lorem ipsum dolor sit amet",
                    },
                    {
                        id: 4,
                        text: "Lorem ipsum dolor sit amet",
                    },
                ]
            },
            {
                id: 2,
                name: "Essential",
                description: "Lorem ipsum dolor sit amet",
                corePrice: 12000000,
                monthlyPrice: 1199000,
                annualPrice: 12500000,
                priceDescriptionText: "Save up to 15% annually",
                features: [
                    {
                        id: 1,
                        text: "Lorem ipsum dolor sit amet",
                    },
                    {
                        id: 2,
                        text: "Lorem ipsum dolor sit amet",
                    },
                    {
                        id: 3,
                        text: "Lorem ipsum dolor sit amet",
                    },
                    {
                        id: 4,
                        text: "Lorem ipsum dolor sit amet",
                    },
                    {
                        id: 5,
                        text: "Lorem ipsum dolor sit amet",
                    },
                    {
                        id: 6,
                        text: "Lorem ipsum dolor sit amet",
                    },
                ]
            },
            {
                id: 3,
                name: "Professional",
                description: "Lorem ipsum dolor sit amet",
                corePrice: 18000000,
                monthlyPrice: 1899000,
                annualPrice: 20000000,
                priceDescriptionText: "Save up to 15% annually",
                features: [
                    {
                        id: 1,
                        text: "Lorem ipsum dolor sit amet",
                    },
                    {
                        id: 2,
                        text: "Lorem ipsum dolor sit amet",
                    },
                    {
                        id: 3,
                        text: "Lorem ipsum dolor sit amet",
                    },
                    {
                        id: 4,
                        text: "Lorem ipsum dolor sit amet",
                    },
                    {
                        id: 5,
                        text: "Lorem ipsum dolor sit amet",
                    },
                    {
                        id: 6,
                        text: "Lorem ipsum dolor sit amet",
                    },
                    {
                        id: 7,
                        text: "Lorem ipsum dolor sit amet",
                    },
                    {
                        id: 8,
                        text: "Lorem ipsum dolor sit amet",
                    },
                    {
                        id: 9,
                        text: "Lorem ipsum dolor sit amet",
                    },
                ]
            },
        ],
    },
    {
        name: "1-on-1 Video Conferencing Platform",
        description: "Virtual meeting platform designed for 1-on-1 communication, easier than ever.",
        slug: "1-on-1-video-conferencing-platform",
        icon: VideoIcon,
        beta: true,
        // details: {
        //     title: "All in one online store to sell your products",
        //     subtitle: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique. Nec in est cursus eu et id viverra scelerisque gravida. ",
        //     img: showcase4,
        //     brands: [
        //         {
        //             id: 1,
        //             name: "aesop",
        //             src: aesop
        //         },
        //         {
        //             id: 2,
        //             name: "rmit",
        //             src: rmit
        //         },
        //         {
        //             id: 3,
        //             name: "glossier",
        //             src: glossier
        //         },
        //         {
        //             id: 4,
        //             name: "mecca",
        //             src: mecca
        //         },
        //         {
        //             id: 5,
        //             name: "adelaide",
        //             src: adelaide
        //         },
        //     ],
        //     body: [
        //         {
        //             title: "Build ecommerce site simpler with easy-to-use interface",
        //             className: style1.className,
        //             itemGroupClassName: style1.itemGroupClassName,
        //             itemClassName: style1.itemClassName,
        //             itemTextClassName: style1.itemTextClassName,
        //             items: [
        //                 {
        //                     img: product1item1,
        //                     title2: "Show product catalogs with",
        //                     description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
        //                 },
        //                 {
        //                     img: product1item1,
        //                     title2: "Manage product inventory",
        //                     description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
        //                 },
        //                 {
        //                     img: product1item1,
        //                     title2: "Easily manage orders and set shipping options",
        //                     description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
        //                 },
        //                 {
        //                     img: product1item1,
        //                     title2: "Notifications for low stock alerts",
        //                     description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
        //                 },
        //                 {
        //                     img: product1item1,
        //                     title2: "Connect and integrate with marketplace",
        //                     description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
        //                 },
        //                 {
        //                     img: product1item1,
        //                     title2: "Add custom discounts or coupons",
        //                     description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
        //                 },
        //             ]
        //         },
        //         {
        //             name: "features",
        //             title: "Ecommerce website that built with exciting core features",
        //             description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique. Nec in est cursus eu et id viverra scelerisque gravida.",
        //             className: style2.className,
        //             itemGroupClassName: style2.itemGroupClassName,
        //             itemClassName: style2.itemClassName,
        //             itemAlternating: style2.itemAlternating,
        //             itemTextClassName: style2.itemTextClassName,
        //             items: [
        //                 {
        //                     img: product1item2,
        //                     title: "View comprehensive analytics of your store",
        //                     description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
        //                 },
        //                 {
        //                     img: product1item3,
        //                     title: "Complete with access management level",
        //                     description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
        //                 },
        //                 {
        //                     img: product1item4,
        //                     title: "Automatic orders management",
        //                     description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
        //                 },
        //             ]
        //         },
        //         {
        //             title: "Lorem ipsum dolor sit amet",
        //             className: style3.className,
        //             itemGroupClassName: style3.itemGroupClassName,
        //             itemClassName: style3.itemClassName,
        //             itemTextClassName: style3.itemTextClassName,
        //             items: [
        //                 {
        //                     title3: "Lorem ipsum",
        //                     list: [
        //                         {
        //                             text: "Custom shipping fee",
        //                         },
        //                         {
        //                             text: "Add product variants",
        //                         },
        //                         {
        //                             text: "Customizable field for product information",
        //                         },
        //                     ]
        //                 },
        //                 {
        //                     title3: "Lorem ipsum",
        //                     list: [
        //                         {
        //                             text: "Custom shipping fee",
        //                         },
        //                         {
        //                             text: "Add product variants",
        //                         },
        //                         {
        //                             text: "Customizable field for product information",
        //                         },
        //                     ]
        //                 },
        //                 {
        //                     title3: "Lorem ipsum",
        //                     list: [
        //                         {
        //                             text: "Custom shipping fee",
        //                         },
        //                         {
        //                             text: "Add product variants",
        //                         },
        //                         {
        //                             text: "Customizable field for product information",
        //                         },
        //                     ]
        //                 },
        //                 {
        //                     title3: "Lorem ipsum",
        //                     list: [
        //                         {
        //                             text: "Custom shipping fee",
        //                         },
        //                         {
        //                             text: "Add product variants",
        //                         },
        //                         {
        //                             text: "Customizable field for product information",
        //                         },
        //                     ]
        //                 },
        //             ]
        //         },
        //     ],
        //     useCases: [
        //         {
        //             icon: HomeIcon,
        //             label: "Fashion"
        //         },
        //         {
        //             icon: HomeIcon,
        //             label: "Home and decor"
        //         },
        //         {
        //             icon: HomeIcon,
        //             label: "Food"
        //         },
        //         {
        //             icon: HomeIcon,
        //             label: "Real estate"
        //         },
        //         {
        //             icon: HomeIcon,
        //             label: "Local business"
        //         },
        //         {
        //             icon: HomeIcon,
        //             label: "Restaurant"
        //         },
        //     ]
        // },
    },
    {
        name: "Event registration and management",
        description: "Deliver a hassle-free registration experience for your attendees and reduce manual processes to manage your event.",
        slug: "event-registration-and-management",
        icon: CouponIcon,
        beta: true,
    }
    // {
    //     name: "Coupons/Voucher Management System",
    //     description: "Lorem ipsum dolor sit amet consectetur. Vitae lacus quis pharetra faucibus a enim vel risus.",
    //     slug: "coupon-voucher-management-system",
    //     icon: CouponIcon,
    //     details: {
    //         title: "All in one online store to sell your products",
    //         subtitle: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique. Nec in est cursus eu et id viverra scelerisque gravida. ",
    //         img: product1item4,
    //         brands: [
    //             {
    //                 id: 1,
    //                 name: "aesop",
    //                 src: aesop
    //             },
    //             {
    //                 id: 2,
    //                 name: "rmit",
    //                 src: rmit
    //             },
    //             {
    //                 id: 3,
    //                 name: "glossier",
    //                 src: glossier
    //             },
    //             {
    //                 id: 4,
    //                 name: "mecca",
    //                 src: mecca
    //             },
    //             {
    //                 id: 5,
    //                 name: "adelaide",
    //                 src: adelaide
    //             },
    //         ],
    //         body: [
    //             {
    //                 title: "Build ecommerce site simpler with easy-to-use interface",
    //                 className: style1.className,
    //                 itemGroupClassName: style1.itemGroupClassName,
    //                 itemClassName: style1.itemClassName,
    //                 itemTextClassName: style1.itemTextClassName,
    //                 items: [
    //                     {
    //                         img: product1item1,
    //                         title2: "Show product catalogs with",
    //                         description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
    //                     },
    //                     {
    //                         img: product1item1,
    //                         title2: "Manage product inventory",
    //                         description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
    //                     },
    //                     {
    //                         img: product1item1,
    //                         title2: "Easily manage orders and set shipping options",
    //                         description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
    //                     },
    //                     {
    //                         img: product1item1,
    //                         title2: "Notifications for low stock alerts",
    //                         description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
    //                     },
    //                     {
    //                         img: product1item1,
    //                         title2: "Connect and integrate with marketplace",
    //                         description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
    //                     },
    //                     {
    //                         img: product1item1,
    //                         title2: "Add custom discounts or coupons",
    //                         description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
    //                     },
    //                 ]
    //             },
    //             {
    //                 name: "features",
    //                 title: "Ecommerce website that built with exciting core features",
    //                 description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique. Nec in est cursus eu et id viverra scelerisque gravida.",
    //                 className: style2.className,
    //                 itemGroupClassName: style2.itemGroupClassName,
    //                 itemClassName: style2.itemClassName,
    //                 itemAlternating: style2.itemAlternating,
    //                 itemTextClassName: style2.itemTextClassName,
    //                 items: [
    //                     {
    //                         img: product1item2,
    //                         title: "View comprehensive analytics of your store",
    //                         description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
    //                     },
    //                     {
    //                         img: product1item3,
    //                         title: "Complete with access management level",
    //                         description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
    //                     },
    //                     {
    //                         img: product1item4,
    //                         title: "Automatic orders management",
    //                         description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
    //                     },
    //                 ]
    //             },
    //             {
    //                 title: "Lorem ipsum dolor sit amet",
    //                 className: style3.className,
    //                 itemGroupClassName: style3.itemGroupClassName,
    //                 itemClassName: style3.itemClassName,
    //                 itemTextClassName: style3.itemTextClassName,
    //                 items: [
    //                     {
    //                         title3: "Lorem ipsum",
    //                         list: [
    //                             {
    //                                 text: "Custom shipping fee",
    //                             },
    //                             {
    //                                 text: "Add product variants",
    //                             },
    //                             {
    //                                 text: "Customizable field for product information",
    //                             },
    //                         ]
    //                     },
    //                     {
    //                         title3: "Lorem ipsum",
    //                         list: [
    //                             {
    //                                 text: "Custom shipping fee",
    //                             },
    //                             {
    //                                 text: "Add product variants",
    //                             },
    //                             {
    //                                 text: "Customizable field for product information",
    //                             },
    //                         ]
    //                     },
    //                     {
    //                         title3: "Lorem ipsum",
    //                         list: [
    //                             {
    //                                 text: "Custom shipping fee",
    //                             },
    //                             {
    //                                 text: "Add product variants",
    //                             },
    //                             {
    //                                 text: "Customizable field for product information",
    //                             },
    //                         ]
    //                     },
    //                     {
    //                         title3: "Lorem ipsum",
    //                         list: [
    //                             {
    //                                 text: "Custom shipping fee",
    //                             },
    //                             {
    //                                 text: "Add product variants",
    //                             },
    //                             {
    //                                 text: "Customizable field for product information",
    //                             },
    //                         ]
    //                     },
    //                 ]
    //             },
    //         ],
    //         useCases: [
    //             {
    //                 icon: HomeIcon,
    //                 label: "Fashion"
    //             },
    //             {
    //                 icon: HomeIcon,
    //                 label: "Home and decor"
    //             },
    //             {
    //                 icon: HomeIcon,
    //                 label: "Food"
    //             },
    //             {
    //                 icon: HomeIcon,
    //                 label: "Real estate"
    //             },
    //             {
    //                 icon: HomeIcon,
    //                 label: "Local business"
    //             },
    //             {
    //                 icon: HomeIcon,
    //                 label: "Restaurant"
    //             },
    //         ]
    //     },
    // },
    // {
    //     name: "Guest Management System",
    //     description: "Lorem ipsum dolor sit amet consectetur. Vitae lacus quis pharetra faucibus a enim vel risus.",
    //     slug: "guest-management-system",
    //     icon: GuestManagementIcon,
    //     details: {
    //         title: "All in one online store to sell your products",
    //         subtitle: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique. Nec in est cursus eu et id viverra scelerisque gravida. ",
    //         img: product1item4,
    //         brands: [
    //             {
    //                 id: 1,
    //                 name: "aesop",
    //                 src: aesop
    //             },
    //             {
    //                 id: 2,
    //                 name: "rmit",
    //                 src: rmit
    //             },
    //             {
    //                 id: 3,
    //                 name: "glossier",
    //                 src: glossier
    //             },
    //             {
    //                 id: 4,
    //                 name: "mecca",
    //                 src: mecca
    //             },
    //             {
    //                 id: 5,
    //                 name: "adelaide",
    //                 src: adelaide
    //             },
    //         ],
    //         body: [
    //             {
    //                 title: "Build ecommerce site simpler with easy-to-use interface",
    //                 className: style1.className,
    //                 itemGroupClassName: style1.itemGroupClassName,
    //                 itemClassName: style1.itemClassName,
    //                 itemTextClassName: style1.itemTextClassName,
    //                 items: [
    //                     {
    //                         img: product1item1,
    //                         title2: "Show product catalogs with",
    //                         description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
    //                     },
    //                     {
    //                         img: product1item1,
    //                         title2: "Manage product inventory",
    //                         description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
    //                     },
    //                     {
    //                         img: product1item1,
    //                         title2: "Easily manage orders and set shipping options",
    //                         description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
    //                     },
    //                     {
    //                         img: product1item1,
    //                         title2: "Notifications for low stock alerts",
    //                         description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
    //                     },
    //                     {
    //                         img: product1item1,
    //                         title2: "Connect and integrate with marketplace",
    //                         description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
    //                     },
    //                     {
    //                         img: product1item1,
    //                         title2: "Add custom discounts or coupons",
    //                         description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
    //                     },
    //                 ]
    //             },
    //             {
    //                 name: "features",
    //                 title: "Ecommerce website that built with exciting core features",
    //                 description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique. Nec in est cursus eu et id viverra scelerisque gravida.",
    //                 className: style2.className,
    //                 itemGroupClassName: style2.itemGroupClassName,
    //                 itemClassName: style2.itemClassName,
    //                 itemAlternating: style2.itemAlternating,
    //                 itemTextClassName: style2.itemTextClassName,
    //                 items: [
    //                     {
    //                         img: product1item2,
    //                         title: "View comprehensive analytics of your store",
    //                         description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
    //                     },
    //                     {
    //                         img: product1item3,
    //                         title: "Complete with access management level",
    //                         description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
    //                     },
    //                     {
    //                         img: product1item4,
    //                         title: "Automatic orders management",
    //                         description: "Lorem ipsum dolor sit amet consectetur. Neque ut facilisis laoreet sapien tristique."
    //                     },
    //                 ]
    //             },
    //             {
    //                 title: "Lorem ipsum dolor sit amet",
    //                 className: style3.className,
    //                 itemGroupClassName: style3.itemGroupClassName,
    //                 itemClassName: style3.itemClassName,
    //                 itemTextClassName: style3.itemTextClassName,
    //                 items: [
    //                     {
    //                         title3: "Lorem ipsum",
    //                         list: [
    //                             {
    //                                 text: "Custom shipping fee",
    //                             },
    //                             {
    //                                 text: "Add product variants",
    //                             },
    //                             {
    //                                 text: "Customizable field for product information",
    //                             },
    //                         ]
    //                     },
    //                     {
    //                         title3: "Lorem ipsum",
    //                         list: [
    //                             {
    //                                 text: "Custom shipping fee",
    //                             },
    //                             {
    //                                 text: "Add product variants",
    //                             },
    //                             {
    //                                 text: "Customizable field for product information",
    //                             },
    //                         ]
    //                     },
    //                     {
    //                         title3: "Lorem ipsum",
    //                         list: [
    //                             {
    //                                 text: "Custom shipping fee",
    //                             },
    //                             {
    //                                 text: "Add product variants",
    //                             },
    //                             {
    //                                 text: "Customizable field for product information",
    //                             },
    //                         ]
    //                     },
    //                     {
    //                         title3: "Lorem ipsum",
    //                         list: [
    //                             {
    //                                 text: "Custom shipping fee",
    //                             },
    //                             {
    //                                 text: "Add product variants",
    //                             },
    //                             {
    //                                 text: "Customizable field for product information",
    //                             },
    //                         ]
    //                     },
    //                 ]
    //             },
    //         ],
    //         useCases: [
    //             {
    //                 icon: HomeIcon,
    //                 label: "Fashion"
    //             },
    //             {
    //                 icon: HomeIcon,
    //                 label: "Home and decor"
    //             },
    //             {
    //                 icon: HomeIcon,
    //                 label: "Food"
    //             },
    //             {
    //                 icon: HomeIcon,
    //                 label: "Real estate"
    //             },
    //             {
    //                 icon: HomeIcon,
    //                 label: "Local business"
    //             },
    //             {
    //                 icon: HomeIcon,
    //                 label: "Restaurant"
    //             },
    //         ]
    //     },
    // },
]

export const faq = [
    {
        question: "Can I use my own design?",
        answer: "Mapplexon has available template designs to begin with. You may modify a minor changes from the existing template with additional cost, please consult with our team."
    },
    {
        question: "Does Maplexxon software include with hosting?",
        answer: "Yes, hosting will be provided from the selected package."
    },
    {
        question: "Do I get the source code?",
        answer: "Unfortunately, the source code is not transferrable."
    },
    {
        question: "How do I manage the software I subscribed from Maplexxon?",
        answer: "We provide Admin Panel Dashboard as Content Management System (CMS) to manage the platform."
    },
    {
        question: "What can I sell using this platform?",
        answer: "Mapplexon has several solutions for your business depending on your needs. You can build company website landing page, online store (e-commerce), website with booking/scheduling system, 1-on-1 virtual meeting software, and others."
    },
    {
        question: "Is my data safe?",
        answer: "Yes, security is our top priority. Your data is safely stored in a trusted and leading partner cloud storage."
    },
    {
        question: "How to order and subscribe to Maplexxon software?",
        answer: "You can see the product options on our website page first and after schedulling a demo with our team, proceed with the order and payment."
    },
    {
        question: "How do I make payment for subscription?",
        answer: "After filling out the order form, payment can be made via Bank Transfer."
    },
    {
        question: "Is there an affiliate program in Maplexxon?",
        answer: (
            <p>Yes, we do provide a Partner Program, where you can register as our Referral or Reseller. Details can be seen on this page <a className="text-maplexxon-blue" href="/partner-program">www.maplexxon.com/partner-program</a>.</p>
        )
    },
    {
        question: "What kind of support does Maplexxon provide?",
        answer: "We provide basic maintenance service for the software that includes in the monthly maintenance fee. But, worry not, we can offer you a content management service and all-in-one support to ensure your platform is well-managed."
    },
    {
        question: "Can I host my website somewhere else?",
        answer: "Unfortunately, we only support the website hosting with our trusted partners."
    },
    {
        question: "I already have a website, how can I integrate with Maplexxon software?",
        answer: "Of course, you can integrate your current website with our products. Please contact our team for the pricing and integration process."
    },
    {
        question: "How long does it take for my website/platform to go-live?",
        answer: (
            <>
                <p>
                    Once you purchase a subscription with us, it will take about 14-20 working days to go- live *.
                </p>
                <br />
                <p>
                    * Time may vary depends on the website content given from Client
                </p>
            </>
        )
    },
    {
        question: "Can I build a custom website that are not listed in Maplexxon software products?",
        answer: (
            <p>Absolutely, you can consult to our group company - <a className="text-maplexxon-blue" href="https://cloudxier.com">Cloudxier</a> and make custom software to mobile app as you wish for.</p>
        )
    },
    {
        question: "What if I exceeds the limit included in the package plan?",
        answer: "Talk to our team to upgrade and increase the limit. Variety of add-ons and limit upgrades for your package can be purchased at any time."
    },
    {
        question: "Do you provide a dedicated support to set everything up?",
        answer: "Yes, we do! For the Professional plans users, we provide a complimentary dedicated Customer Success Manager to work closely with you to address related queries you may have about the software."
    },
    {
        question: "Are there any hidden fees?",
        answer: "The pricing listed is inclusive with applicable taxes. There are no hidden fees other than set-up fees and subscription fees."
    },
    {
        question: "Can I cancel my subscription?",
        answer: "Yes, you can cancel your account anytime."
    },
    {
        question: "Will my billing pro-rated if I sign up for subscription in the middle of the month?",
        answer: (
            <p>
                Yes, your billing cycle will be calculated from the go-live date. For example: If you sign up on the 15<sup>th</sup> of the month, your next monthly billing cycle will be the 15<sup>th</sup> on the following month.
            </p>
        )
    },
    {
        question: "Is my domain secure?",
        answer: "Every domain that you purchase from Maplexxon includes a 2048-bit SSL certificate and WHOIS privacy."
    },
    {
        question: "I have my own domain already, can I transfer my domain to Maplexxon?",
        answer: "Yes, we do provide domain transfer service. You can connect your website from Maplexxon with domain that you have purchased from third-party provider (such as: GoDaddy, Google, etc)."
    },
    {
        question: "Does Maplexxon support responsive and mobile-friendly sites?",
        answer: "All of our websites/software are responsive, enabling your customers to access the site from tablet or mobile devices."
    },
]